import { render, staticRenderFns } from "./NumberVal.vue?vue&type=template&id=688ac68e&scoped=true&"
import script from "./NumberVal.vue?vue&type=script&lang=js&"
export * from "./NumberVal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688ac68e",
  null
  
)

export default component.exports